export const DATA_PROCESSING_GDPR_AGREEMENT = 'data_processing';
export const MARKETING_GDPR_AGREEMENT = 'marketing';
export const EMAIL_GDPR_AGREEMENT = 'email';
export const SMS_PHONE_GDPR_AGREEMENT = 'sms_phone';
export const SMS_GDPR_AGREEMENT = 'sms';
export const PHONE_GDPR_AGREEMENT = 'phone';
